module.exports = __webpack_public_path__ + "img/HappyPhoto43.54e47181.jpeg";